"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDurationHourMinSecStr = exports.getDurationHourMinSecObject = exports.getDurationSecondsStr = exports.getDurationHourMinStr = exports.getDurationMinSecStr = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const TypeHelpers_1 = require("../TypeHelpers");
/**
 * The number of minutes and seconds from `tZeroMs` until now
 */
const getDurationMinSecStr = (tZeroMs) => {
    const duration = Date.now() - tZeroMs;
    return `${Math.floor(duration / iotv_v3_types_1.Milliseconds.MINUTE)} min ${(0, TypeHelpers_1.roundDecimals)((duration % iotv_v3_types_1.Milliseconds.MINUTE) / iotv_v3_types_1.Milliseconds.SECOND, 2)} secs`;
};
exports.getDurationMinSecStr = getDurationMinSecStr;
const getDurationHourMinStr = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);
    let res = '';
    if (hours !== 0) {
        res += hours + ' hours ';
    }
    if (hours === 0 || minutes !== 0) {
        res += minutes + ' minutes';
    }
    return res;
};
exports.getDurationHourMinStr = getDurationHourMinStr;
/**
 * The number seconds with milliseconds as decismal from `tZeroMs` until now
 */
const getDurationSecondsStr = (tZeroMs) => {
    const duration = Date.now() - tZeroMs;
    return `${duration / iotv_v3_types_1.Milliseconds.SECOND} secs`;
};
exports.getDurationSecondsStr = getDurationSecondsStr;
/**
 * Duration in days, hours, minutes, and seconds. Based on an input of number of millesconds (eg: t1 - t0 )
 */
const getDurationHourMinSecObject = (durationMs) => {
    const d = Math.floor(durationMs / iotv_v3_types_1.Milliseconds.DAY);
    const h = Math.floor((durationMs % iotv_v3_types_1.Milliseconds.DAY) / iotv_v3_types_1.Milliseconds.HOUR);
    const m = Math.floor((durationMs % iotv_v3_types_1.Milliseconds.HOUR) / iotv_v3_types_1.Milliseconds.MINUTE);
    const s = Math.floor((durationMs % iotv_v3_types_1.Milliseconds.MINUTE) / iotv_v3_types_1.Milliseconds.SECOND);
    return { d, h, m, s };
};
exports.getDurationHourMinSecObject = getDurationHourMinSecObject;
/**
 * Duration in days, hours, minutes, and seconds
 *
 * @example
 * ```
 * 34m 10s
 * ```
 *
 * @example
 * ```
 * 1d 6h 18m 24s
 * ```
 *
 * @example
 * ```
 * 7d
 * ```
 *
 * @example
 * ```
 * 1d 3m
 * ```
 */
const getDurationHourMinSecStr = (durationMs) => {
    let res = '';
    const { d, h, m, s } = (0, exports.getDurationHourMinSecObject)(durationMs);
    d && (res += `${d}d `);
    h && (res += `${h}h `);
    m && (res += `${m}m `);
    s && (res += `${s}s `);
    return res;
};
exports.getDurationHourMinSecStr = getDurationHourMinSecStr;
